import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import { Flex, Tooltip } from '@ads/front-ds'
import { TabCard } from './interfaces'
import { TabsCardItem } from './TabCardItem'

interface ITabsCard {
  selectedTab: string | number
  tabs: TabCard[]
}

export const TabsCard: FC<ITabsCard> = ({ selectedTab, tabs }) => (
  <StyledTabs>
    {tabs.map(tab => (
      <React.Fragment key={tab.id}>
        {tab.tooltip ? (
          <Tooltip text={tab.tooltip} placement="top">
            <TabsCardItem isSelected={selectedTab === tab.id} tab={tab} />
          </Tooltip>
        ) : (
          <TabsCardItem isSelected={selectedTab === tab.id} tab={tab} />
        )}
      </React.Fragment>
    ))}
  </StyledTabs>
)

const StyledTabs = styled(Flex)`
  ${p => css`
    position: relative;
    border-bottom: ${p.theme.borders.thinGrey20};
  `}
`
